<template>
  <div v-loading="loading" class="container">
    <div class="row">
      <div class="col-12 col-sm-4 mb-sm-5 font-weight-bold">Sale Summary CSV</div>
      <div class="col-12 col-sm-8 mb-sm-5">
        <div class="input-group">
          <el-upload
            ref="sale_summary_csv"
            action
            :file-list="fileListSaleSummaryCsv"
            :on-change="handleUploadSaleSummaryCsv"
            :multiple="false"
            :auto-upload="false"
            >
              <el-button size="small" type="primary">Select Summary CSV</el-button>
            </el-upload>
        </div>
      </div>

      <div class="col-12 col-sm-4 mb-sm-5 font-weight-bold">Sale Invoice</div>
      <div class="col-12 col-sm-8 mb-sm-5">
        <div class="input-group">
          <el-upload
            ref="sale_invoice"
            action
            :file-list="fileListSaleInvoice"
            :on-change="handleUploadSaleInvoice"
            :multiple="false"
            :auto-upload="false"
            >
              <el-button size="small" type="primary">Select Invoice</el-button>
            </el-upload>
        </div>
      </div>

      <div class="col-12 col-sm-4 mb-sm-5 font-weight-bold">Induction Data/Kill Sheet</div>
      <div class="col-12 col-sm-8 mb-sm-5">
        <div class="input-group">
          <el-upload
            ref="induction_data_kill_sheet"
            action
            :file-list="fileListDataKillSheet"
            :on-change="handleUploadDataKilfileListDataKillSheet"
            :multiple="false"
            :auto-upload="false"
            >
              <el-button size="small" type="primary">Select File</el-button>
            </el-upload>
        </div>
      </div>

      <div class="col-12 col-sm-4 mb-sm-5 font-weight-bold">Ottley Settlement Date</div>
      <div class="col-12 col-sm-8 mb-sm-5">
        <el-date-picker
          class="w-100"
          type="date"
          format="dd/MM/yyyy"
          value-format="yyyy-MM-dd"
          placeholder="Pick a day"
          v-model="sale.date_of_sale"
        />
      </div>

      <div class="col-12 col-sm-4 mb-sm-5 font-weight-bold">Buyers Name</div>
      <div class="col-12 col-sm-8 mb-sm-5">
        <el-input v-model="sale.purchaser_name" />
      </div>

      <div class="col-12 col-sm-4 mb-sm-5 font-weight-bold">End Market</div>
      <div class="col-12 col-sm-8 mb-sm-5">
        <el-select class="w-100" v-model="sale.end_market_id">
          <el-option v-for="item in endMarkets" :key="item.id" :label="item.name" :value="item.id" />
        </el-select>
      </div>

      <div class="col-12 col-sm-4 mb-sm-5 font-weight-bold">Total No. of Head</div>
      <div class="col-12 col-sm-8 mb-sm-5">
        <el-input v-model="sale.number_of_head" />
      </div>

      <div class="col-12 col-sm-4 mb-sm-5 font-weight-bold">Average Weight</div>
      <div class="col-12 col-sm-8 mb-sm-5">
        <el-input v-model="sale.average_weight" />
      </div>
    </div>
    <div class="row">
      <div class="col-12 d-flex justify-content-between">
        <!-- <el-button
          class="el-button el-button--primary is-plain"
          @click="handleSaveAsDraft"
        >Save as Draft</el-button> -->
        <el-button
          class="el-button el-button--primary is-plain"
          @click="handleSubmit"
        >Submit for Approval</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import Sale from "../../../models/Sale";

export default {
  props: {
    endMarkets: {
      type: Array,
    },
    business: {
      type: Object,
    },
  },
  data() {
    return {
      loading: false,
      fileListSaleSummaryCsv: [],
      fileListSaleInvoice: [],
      fileListDataKillSheet: [],
      settlement_date: null,
      sale: new Sale({
        date_of_sale: null,
        purchaser_name: null,
        end_market_id: null,
        number_of_head: null,
        average_weight: null,
      }).for(this.business),
    };
  },
  methods: {
    getDataForUpload: function(type) {
      if(type == 'csv') {
        return {
          collection: 'sale_summary_csv_collection'
        }
      }
    },
    handleSaveAsDraft: function () {
      console.log("handle draft clicked... wip");
    },
    handleUploadSaleSummaryCsv(file){
      this.fileListSaleSummaryCsv = [file];
    },
    handleUploadSaleInvoice(file){
      this.fileListSaleInvoice = [file];
    },
    handleUploadDataKilfileListDataKillSheet(file){
      this.fileListDataKillSheet = [file];
    },
    handleSubmit: function () {
      this.loading = true;
      let form_data = new FormData();
      // build form data
      for (const [key, value] of Object.entries(this.sale)) {
        form_data.append(key, value);
      }
      if (this.$refs.sale_summary_csv.fileList.length > 0) form_data.append('sale_summary_csv', this.$refs.sale_summary_csv.fileList[0].raw);
      if (this.$refs.sale_invoice.fileList.length > 0) form_data.append('sale_invoice', this.$refs.sale_invoice.fileList[0].raw);
      if (this.$refs.induction_data_kill_sheet.fileList.length > 0) form_data.append('induction_data_kill_sheet', this.$refs.induction_data_kill_sheet.fileList[0].raw);

      axios
        .post(
          `/api/v1/businesses/${this.business.id}/sales`,
          form_data,
          {
            headers: { "content-type": "multipart/form-data" }
          }
        )
        .then(() => {
          this.$message.success("Submitted Successfully");
          this.$emit("submit-successful");
        })
        .catch((errors) => {})
        .finally(() => {
          this.loading = false;
        });
    }
  },
};
</script>

<style lang="scss" scoped>
</style>